import * as React from 'react'
import { Link as RouterLink, useLocation } from 'react-router-dom'
import MUILink from '@mui/material/Link'

import { parseURL, urlToRelative } from '~/client/lib/urls'

const Link = React.forwardRef((_props, ref) => {
  const {
    variant = 'none',
    newWindow = false,
    returnTo,
    underline = variant === 'text' ? 'hover' : undefined,
    ...props
  } = _props
  props.underline = underline
  const location = useLocation()
  if (returnTo && props.to){
    const url = parseURL(props.to)
    url.searchParams.set('returnTo', returnTo === true
      ? urlToRelative(location)
      : returnTo
    )
    props.to = urlToRelative(url)
  }
  if (newWindow) props.target = '_blank'
  props.component ??= RouterLink
  if (
    props.to &&
    (
      props.to.startsWith('/api/') ||
      (
        props.to.startsWith('http') &&
        !props.to.startsWith(process.env.APP_ORIGIN)
      )
    )
  ) {
    props.component = 'a'
    props.href = props.to
    delete props.to
    // props.reloadDocument = true
    props.rel ??= "noopener noreferrer"
  }
  return <MUILink {...props} ref={ref}/>
})

Link.displayName = 'Link'

export default Link
